import { clsx, type ClassValue } from 'clsx';

/**
 * Thin wrapper over `clsx`. We re-export through `cn` so we can swap the
 * implementation later (e.g. tailwind-merge) without touching every caller.
 */
export const cn = (...inputs: ClassValue[]): string => clsx(inputs);
